<template>
  <RightDrawer :moreInfo="false" ref="drawer">
    <h-loading v-if="isServiceProviderLoading" />
    <div v-else>
      <v-row no-gutters>
        <v-col cols="10">
          <h6 class="text-uppercase grey--text"> {{ nameLabel }} </h6>
          <p class="body-2"> {{ name }} </p>
        </v-col>
        <v-col cols="2">
          <h6 class="text-uppercase grey--text"> {{ statusLabel }} </h6>
          <p class="body-2"> {{ status }} </p>
        </v-col>
      </v-row>

      <h6 class="text-uppercase grey--text"> {{ emailLabel }} </h6>
      <p class="body-2"> {{ email }} </p>

      <v-row no-gutters>
        <v-col>
          <h6 class="text-uppercase grey--text"> {{ phoneLabel }} </h6>
          <p class="body-2"> {{ phone }} </p>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text"> {{ documentLabel }} </h6>
          <p class="body-2"> {{ document }} </p>
        </v-col>
      </v-row>

      <h6 class="text-uppercase grey--text"> {{ cityLabel }} </h6>
      <p class="body-2"> {{ city }} </p>

      <h6 class="text-uppercase grey--text"> {{ serviceProviderLabel }} </h6>
      <p class="body-2"> {{ serviceProvider }} </p>
    </div>
  </RightDrawer>
</template>

<script>
// vue core
import { mapGetters } from 'vuex'

// components
import RightDrawer from '../../../components/app/RightDrawer.vue'

export default {
  name: 'ServiceProviderUserDetails',

  components: {
    RightDrawer,
  },

  computed: {
    ...mapGetters(['isServiceProviderLoading', 'serviceProviderUser']),

    name: {
      get() {
        return this.serviceProviderUser?.name ?? '---'
      },
    },
    email: {
      get() {
        return this.serviceProviderUser?.email ?? '---'
      },
    },
    phone: {
      get() {
        return this.serviceProviderUser?.phone ?? '---'
      },
    },
    city: {
      get() {
        return this.serviceProviderUser?.city?.name ?? '---'
      },
    },
    document: {
      get() {
        return this.serviceProviderUser?.cpf ?? '---'
      },
    },
    status: {
      get() {
        return this.serviceProviderUser?.cpf ? this.$t('defaultServiceValues.label.active') : this.$t('defaultServiceValues.label.inactive')
      },
    },
    serviceProvider: {
      get() {
        return this.serviceProviderUser?.service_provider?.name ?? '---'
      },
    },
  },

  data() {
    return {
      titleLabel: this.$t('hausefulUsers.action.create'),
      nameLabel: this.$t('hausefulUsers.label.name'),
      documentLabel: this.$t('hausefulUsers.label.document'),
      emailLabel: this.$t('hausefulUsers.label.email'),
      phoneLabel: this.$t('hausefulUsers.label.phone'),
      cityLabel: this.$t('hausefulUsers.label.city'),
      passwordLabel: this.$t('hausefulUsers.label.password'),
      repeatPasswordLabel: this.$t('hausefulUsers.label.repeatPassword'),
      statusLabel: this.$t('hausefulUsers.label.status'),
      serviceProviderLabel: this.$t('serviceProviders.single'),
    }
  }
}
</script>
